<template>
<!-- // this loader is shown when showHideSpinner is base store is true -->
  <div class="overlay-loader">
    <div class="loader">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'library-loader'
}
</script>

<style lang="scss">
</style>
